module.exports = __webpack_public_path__ + "assets/qingxiujiashenqing.a9b75ea9.svg";